<template>
	<div>
		<div class="association-btn">
			<el-button @click="association" v-loading="associationState" type="success">关 联</el-button>
		</div>
		<el-divider class="m5"></el-divider>
		<div class="match-box">
			<div class="item">
				<div class="title">账户</div>
				<div class="select-box">
					<div class="select-item">
						<div class="select-label">账户名称</div>
						<el-input placeholder="请输入内容" v-model="searchStr" class="input-with-select">
							<!-- <el-select v-model="searchType" slot="prepend" placeholder="请选择">
								<el-option label="账户名称" value="accountName"></el-option>
								<el-option label="账号/卡号" value="account"></el-option>
							</el-select> -->
						</el-input>
					</div>
					<div class="select-item">
						<div class="select-label">账户类型</div>
						<el-select v-model="accountType" slot="prepend" placeholder="请选择" filterable clearable>
							<el-option label="银行卡" value="银行卡"></el-option>
							<el-option label="信用卡" value="信用卡"></el-option>
							<el-option label="pingpong" value="pingpong"></el-option>
							<el-option label="GEP" value="GEP"></el-option>
							<el-option label="万里汇" value="万里汇"></el-option>
							<el-option label="空中云汇" value="空中云汇"></el-option>
							<el-option label="连连支付" value="连连支付"></el-option>
							<el-option label="支付宝" value="支付宝"></el-option>
							<el-option label="微信" value="微信"></el-option>
							<el-option label="诚e付" value="诚e付"></el-option>
						</el-select>
					</div>
					<div class="select-item">
						<el-button type="primary" @click="getAccountData">查询</el-button>
						<el-button type="primary" @click="initAccountData">重置</el-button>
						<el-button type="primary" @click="cancelSelectAccount">取消选择</el-button>
					</div>
				</div>
				<el-table stripe v-loading="loadAccoutData" :data="accountData" border tooltip-effect="dark"
					highlight-current-row @current-change="handleAccountCurrentChange" style="width: 100%"
					height="calc(100% - 120px)" ref="accountTable">
					<el-table-column type="index" width="45"></el-table-column>
					<!-- <el-table-column type="selection" width="38" align="center"></el-table-column> -->
					<el-table-column label="账户类型" prop="accountType" width="110">
					</el-table-column>
					<!-- <el-table-column prop="account" label="账号/卡号" width="180">
					</el-table-column> -->
					<el-table-column prop="accountName" label="账户名称" width="180">
					</el-table-column>
					<el-table-column label="关联关系">
						<template slot-scope="scope">
							<p v-for="shop in scope.row.accountCountrySellers" :key="shop.shopId" class="list-item">
								{{ shop.shopName }} {{ shop.countryName ? ' — ' + shop.countryName : '' }}
								<el-button type="text" @click="disconnect(scope.row, shop)">取消关联</el-button>
							</p>
						</template>
					</el-table-column>
				</el-table>
				<div class="page-block">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="page" :page-sizes="[10, 20, 50, 100, 200, 300, 500]" :page-size="size"
						layout="total, sizes, prev, pager, next, jumper" :total="accountTotal">
					</el-pagination>
				</div>
			</div>

			<el-divider direction="vertical"></el-divider>
			<div class="item">
				<div class="title">店铺</div>
				<div class="select-box">
					<div class="select-item">
						<div class="select-label">公司</div>
						<el-select v-model="selectCompany" placeholder="请选择" filterable clearable>
							<el-option v-for="item in companyOpts" :key="item.id" :label="item.companyFullName"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="select-item">
						<div class="select-label">店铺</div>
						<el-input v-model="selectShop" placeholder="请输入店铺名称" filterable clearable>
						</el-input>
					</div>
					<el-button @click="getShopOpts" type="primary">查询</el-button>
					<el-button type="primary" @click="cancelSelectShop">取消选择</el-button>
				</div>
				<el-table stripe :data="shopOpts" border tooltip-effect="dark" style="width: 100%"
				@selection-change="handleSelectionChange" height="calc(100% - 120px)" v-loading="loadShop"
					ref="shopTable">
					<el-table-column
						type="selection"
						width="45">
					</el-table-column>
					<!-- <el-table-column type="index" width="45"></el-table-column> -->
					<!-- <el-table-column type="selection" width="38" align="center"></el-table-column> -->
					<el-table-column prop="platform" label="平台" width="100">
					</el-table-column>
					<el-table-column prop="shop_name" label="店铺名称" width="200">
					</el-table-column>
					<el-table-column prop="countryName" label="站点" width="80" show-overflow-tooltip>
					</el-table-column>
					<el-table-column label="关联关系">
						<template slot-scope="scope">
							<p v-for="shop in scope.row.accountCountrySellers" :key="shop.accountId" class="list-item">
								{{ shop.accountType }} - {{ shop.accountName }}
							</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api.js';
export default {
	name: 'AccountSeller',
	props: {},
	data() {
		return {
			multipleSelection: [],
			companyOpts:[],
			selectCompany: '',
			rightAccountType: '',
			shopOpts:[],
			dictionaryMap: {},
			searchType: 'accountName',
			accountType: '',
			searchStr: '',
			accountData: [],
			accountTotal: 0,
			selectShop: '',
			page: 1,
			size: 10,
			loadAccoutData: false,
			currentAccount: null,
			associationState: false,
			loadShop: false
		};
	},
	watch: {},
	created() {
		this.getDictionaryMap(); //获取平台的字典对照表
		this.getCompanyList();
		this.getAccountData();
	},
	mounted() { },
	computed: {},
	methods: {
		cancelSelectShop(){
			this.$refs.shopTable.clearSelection();
			this.multipleSelection = [];
		},
		cancelSelectAccount(){
			this.$refs.accountTable.setCurrentRow();
			this.currentAccount = null;
		},
		disconnect(rowData, itemData){
			this.$confirm("确定取消关联吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.associationState = true;
					const params = {
						id: itemData['id'],
					}
					ajaxPost(Baseurl + 'incomeExpenditureAccountController/disconnectAccountCountrySeller', params).then((resp) => {
						if (resp.status === 200) {
							const res = resp.data;
							if (res.code === 200) {
								this.$message.success('操作成功');
								this.getAccountData();
								this.getShopOpts();
								// this.companyOpts = res.data;
							} else {
								this.$message.error(res.message)
							}
						}
						this.associationState = false;
					})
				})
				.catch(() => {
					this.cancelSelectAccount();
				});
		},
		association(){
			if (!this.currentAccount){
				this.$message.warning('请选择账户');
				return
			}
			
			if (this.multipleSelection.length == 0) {
				this.$message.warning('至少选择一个店铺');
				return
			}
			this.associationState = true;
			const params = {
				accountId: this.currentAccount['id'],
				countrySellerIds: this.multipleSelection.map(item => item.shopId),
			}
			ajaxPost(Baseurl + 'incomeExpenditureAccountController/insertAccountCountrySeller', params).then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						this.$message.success('关联成功');
						this.getAccountData();
						this.getShopOpts();
						// this.companyOpts = res.data;
					} else {
						this.$message.error(res.message)
					}
				}
				this.associationState = false;
			})
		},
		handleSizeChange(val) {
			this.page = 1;
			this.size = val;
			this.getAccountData();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getAccountData();
		},
		initAccountData(){
			this.page = 1;
			this.size = 10;
			this.searchStr = '';
			this.searchType = 'accountName';
			this.accountType = '';
			this.getAccountData();
		},
		getAccountData(){
			this.loadAccoutData = true;
			const params = {
				"page": this.page,
				"size": this.size,
			}
			if (this.searchStr) {
				params['searchType'] = this.searchType;
				params['searchStr'] = this.searchStr.trim();
			}
			if (this.accountType){
				params['accountType'] = this.accountType
			}
			ajaxPost(Baseurl + 'incomeExpenditureAccountController/selectIncomeExpenditureAccountPage', params).then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						const data = res.data;
						this.accountData = data.list;
						this.accountTotal = data.total;
					} else {
						this.$message.error(res.message);
					}
				}
				this.loadAccoutData = false;
			})
		},
		getDictionaryMap() {
			ajaxPost(Baseurl + 'purchaseController/selectItemList', { itemCode: 'HYXUN0000014' }).then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						const obj = {};
						for (let i = 0; i < res.data.length; i++) {
							obj[res.data[i]['itemTypeId']] = res.data[i]
						}
						this.dictionaryMap = obj;
					} else {
						this.$message.error(res.message)
					}
				}
			})
		},
		getShopOpts() {
			this.loadShop = true;
			const params = {
				company_id: this.selectCompany,
			}
			if (this.rightAccountType){
				params['accountType'] = this.rightAccountType;
			}
			if (this.selectShop){
				params['shop_name'] = this.selectShop.trim();
			}
			if(!this.selectCompany && !this.selectShop){
				this.$message.warning('请选择公司或输入店铺名称');
				this.loadShop = false;
				return
			}
			ajaxPost(Baseurl + 'incomeExpenditureAccountController/selectSellerListByCompanyId', params).then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						const result = [];
						const data = res.data;
						for(let i = 0; i < data.length; i++){
							const obj = {
								platform: this.dictionaryMap[data[i]['sellerType']] ? this.dictionaryMap[data[i]['sellerType']]['itemTypeName'] : '',
								shop_name: data[i]['shopName'],
								countryName: data[i]['countryName'],
								shopId: data[i]['id'],
								accountCountrySellers: data[i]['accountCountrySellers']
							}
							result.push(obj);
						}
						this.shopOpts = result;
					} else {
						this.$message.error(res.message);
					}
				}
				this.loadShop = false;
			})
		},
		handleAccountCurrentChange(val) {
			this.currentAccount = val;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		getCompanyList() {
			ajaxPost(Baseurl + 'companyController/selectAllSubsidiaryCompanyList').then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						this.companyOpts = res.data;
						this.selectCompany = this.companyOpts[0]['id'];
						this.getShopOpts();
					} else {
						this.$message.error(res.message)
					}
				}
			})
		},
	},
	
};
</script>
<style lang="scss" scoped>
.match-box{
	display: flex;
	justify-content: space-between;
	width: 100%;
	height: calc(100vh - 180px);
	.item{
		width: calc((100% - 20px) / 2);
		.title{
			text-align: center;
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 10px;
		}
		.select-box {
			display: flex;
			margin-bottom: 10px;

			.select-item {
				display: flex;
				align-items: center;
				margin-right: 10px;
				width: 290px;

				.select-label {
					margin-right: 5px;
					white-space: nowrap;
				}
				.input-with-select{
					// width: 200px;
				}
				/deep/ .el-input__inner{
					flex: 1;
				}
				

				.el-select {
					flex: 1;
					width: 120px;

					&.w800 {
						width: 800px;
					}
				}
			}
		}

	}
	.el-divider{
		height: 100%;
		margin: 0;
	}
	.page-block {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 10px;
	}
	/deep/ .current-row .el-table__cell{
		background-color: #b4d8ff !important;
	}
}
.association-btn {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	.el-button{
		width: 100px;
	}
}
.m5{
	margin: 5px 0;
}
.el-table .cell{
	.list-item{
		padding-left: 10px;
		line-height: 20px;
		position: relative;
		&::before{
			content: '';
			width: 7px;
			height: 7px;
			background-color: #414141;
			border-radius: 50%;
			position: absolute;
			left: 0;
			top: 7px;
		}
		.el-button{
			padding: 0;
		}
	}
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td {
	background-color: transparent;
}
// .select-item{
// 	width: ;
// }
</style>